import { render } from "./FoamingBodySoap.vue?vue&type=template&id=4dcf4a24&scoped=true"
import script from "./FoamingBodySoap.vue?vue&type=script&lang=js"
export * from "./FoamingBodySoap.vue?vue&type=script&lang=js"

import "../../assets/css/custom.css?vue&type=style&index=0&id=4dcf4a24&scoped=true&lang=css"
import "../../assets/css/module.css?vue&type=style&index=1&id=4dcf4a24&scoped=true&lang=css"
import "../../assets/css/module_sp.css?vue&type=style&index=2&id=4dcf4a24&scoped=true&lang=css"
import "../../assets/css/top.css?vue&type=style&index=3&id=4dcf4a24&scoped=true&lang=css"
import "./FoamingBodySoap.vue?vue&type=style&index=4&id=4dcf4a24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4dcf4a24"

export default script